import React from 'react';
import { View, Pressable } from 'react-native';
import styled from 'styled-components/native';

import { Text } from 'app/src/styles';
import colors from 'app/src/styles/colors';

export const Container = styled(View)`
  flex-direction: row;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: flex-start;
  margin: 12px 0;
`;

export const ButtonContainer = styled(Pressable)`
  justify-content: space-around;
  align-items: center;
  border-width: 2px;
  border-radius: 8px;
  border-color: ${props => props.notSelected ? colors.border : colors.focus};
  background-color: ${props => props.notSelected ? colors.backgroundAlt : colors.background};
  min-width: 80px;
  min-height: 80px;
  padding: 8px;
  opacity: ${props => props.notSelected ? 0.6 : 1};
`;

export const EmojiText = styled(Text)`
  font-size: 36px;
  line-height: 44px;
`;

export const LabelText = styled(Text)`
  font-size: 13px;
  color: ${colors.textLight};
  text-align: center;
  margin-top: 4px;
`;

export const Button = ({ option, handlePress, notSelected }) => {
  return (
    <ButtonContainer
      onPress={() => handlePress(option)}
      notSelected={notSelected}
    >
      <EmojiText>
        {option.emoji || option.name[0]}
      </EmojiText>
      <LabelText>
        {option.name}
      </LabelText>
    </ButtonContainer>
  );
};

const ButtonPicker = ({ value, setValue, options, add }) => {
  const handleOptionPress = option => {
    if (option.id === value) {
      setValue(null);
    } else {
      setValue(option.id)
    }
  };

  return (
    <Container>
      {options.map(option => (
        <Button
          key={option.id}
          option={option}
          handlePress={handleOptionPress}
          notSelected={value && value !== option.id}
        />
      ))}

      {add && (
        <Button
          option={{ name: 'Add', emoji: '+' }}
          handlePress={add}
          notSelected={value}
        />
      )}
    </Container>
  );
};

export default ButtonPicker;
